<template>
    <div class="DashboardLifeskillsVoteView">
        <div class="scrollContainer">
            <MemolifeLogo class="--global-clickable" @click.native="$router.push({ name: 'DashboardHomeView' })" />

            <div class="title">
                {{ $t('title') }}
            </div>
            <div class="subtitle">
                {{ $t('subtitle') }}
            </div>

            <div class="categories">
                <CategorySection
                    v-for="categoryId of categoryIds"
                    :key="categoryId"
                    :category-id="categoryId"
                    @change-count="changeCount"
                />
            </div>
        </div>
        <Footer :button-label="$t('nextButton')" :selections-count="numberOfSelections" @click="gotoNext()" />
    </div>
</template>

<translations>
  title: 'Bygg ditt livshjul'
  subtitle: 'Gjør livslang læring enkelt - utvid interessene dine når det passer deg med anbefalt innhold fra 7 kategorier og 100 ferdigheter.'

  nextButton: 'Done'
  nextButton_no: 'Ferdig'
</translations>

<script>
import MemolifeLogo from '@/components/MemolifeLogo';
import CategorySection from './CategorySection';
import Footer from './Footer';

export default {
    components: { CategorySection, Footer, MemolifeLogo },
    computed: {
        categoryIds() {
            return Object.keys(this.$store.state.moduleApp.categories);
        },
        numberOfSelections() {
            return Object.values(this.$store.state.moduleApp.lifeskills).filter(lifeskill => lifeskill.follow).length;
        }
    },
    methods: {
        gotoNext() {
            this.$router.push({
                name: 'DashboardHomeView'
            });
        },

        changeCount() {
            this._computedWatchers.numberOfSelections.run();

            this.$forceUpdate();
        }
    }
};
</script>

<style lang="scss" scoped>
.DashboardLifeskillsVoteView {
    background: $dashboard-background;
    display: flex;
    flex-direction: column;
}

.scrollContainer {
    overflow-y: auto;
    padding-top: 2em;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.MemolifeLogo {
    margin-bottom: 2em;
}

.title {
    color: rgba(white, 0.9);
    font-size: 200%;
    text-align: center;
}

.subtitle {
    color: rgba(white, 0.7);
    margin-top: 1em;
    line-height: 1.5em;
    text-align: center;
    max-width: 40em;
    padding: 0 1em;
}

.categories {
    width: 100%;
}

@include media('<tablet') {
    .title {
        font-size: 140%;
    }
}
</style>
